define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/cdr/applications/{0}/details/started',
		hasPortalDetail: function(){
			var keys = [];
			var types = this.get('applicationType.detailTypes');
			if ( types && types.models ){
				_.forEach(types.models, t=>{
					var display = t.get('display');
					if ( !_.isNull(display) && _.parseInt(display) ===2 )  {
						keys.push(t.id);
					}
				});
			}
			return keys.length > 0;
		},
		hasAttachmentDetails: function(){
			if(this.useEmbeddedDetailPages){
				var hasAttachments = false;
				var types = this.get('applicationType.detailTypes');
				if ( types && types.models ){
					_.forEach(types.models, detail=>{
						var area = detail.get('portalDetailArea');
						let display = detail.get('display');
						if ( !_.isNull(display) && _.parseInt(display) === 2 && !_.isNull(area) && area == 'Attachments')  {
							hasAttachments = true
						}
					});
				}
				return hasAttachments;
			}
		},
		hasSiteDetails: function(){
			if(this.useEmbeddedDetailPages){
				var hasSites = false;
				var types = this.get('applicationType.detailTypes');
				if ( types && types.models ){
					_.forEach(types.models, detail=>{
						var area = detail.get('portalDetailArea');
						let display = detail.get('display');
						if (!_.isNull(display) && _.parseInt(display) === 2 && !_.isNull(area) && area == 'Sites')  {
							hasSites = true
						}
					});
				}
				return hasSites;
			}
		},
		hasDynamicPages: function(){
			if (this.useEmbeddedDetailPages) {
				var hasDynamicPages = this.get('applicationType.hasDynamicPages');

				return hasDynamicPages == null ? false : JSON.parse(hasDynamicPages);
			}
		},
		filterAttachmentConstraints: function(applicationType) {
			var attachmentConstraints = applicationType.attachmentConstraints;

			applicationType.attachmentConstraints = attachmentConstraints.filter((item) => !item.isElectronicPlanType);
			applicationType.ePlanAttachmentConstraints = attachmentConstraints.filter((item) => item.isElectronicPlanType);

		},
		parse: function (response) {
			if (this.useEmbeddedDetailPages &&
				response.data &&
				response.data.applicationType &&
				response.data.applicationType.detailTypes &&
				response.data.applicationType.detailTypes.length > 0) {
				for (i = 0; i < response.data.applicationType.detailTypes.length; i++){
					//append area and placement
					var area = response.data.applicationType.detailTypes[i].portalDetailArea;
					var placement = response.data.applicationType.detailTypes[i].portalDetailPlacement;
					response.data.applicationType.detailTypes[i].portalSubmitPlacement = area + placement;

					if(this.useAttachmentStep){
						if (response.data.applicationType.detailTypes[i].portalSubmitPlacement.indexOf('Attachments') > -1) {//if this detail page should appear on the attachments
							response.data.applicationType.detailTypes[i].portalSubmitPlacement += 'Step';
						}
					}
				}
			}

			if(response.data && response.data.applicationType) {
				var applicationType = response.data.applicationType;

				if(applicationType !=null) {
					if(	AvailableFeatures.ElectronicPlanForSubmission() &&
						(!AvailableFeatures.ElectronicPlanForCustomersConfig() || applicationType.electronicPlanCustomerSubmittal)) {
							this.filterAttachmentConstraints(response.data.applicationType);
					}
				}
			}


			return response.data;
		}
	});
});
